import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store'; // Import your store and persistor
import { ToastContainer} from 'react-toastify';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        {/* PersistGate ensures that the persisted state is loaded before the app renders */}
        <PersistGate loading={null} persistor={persistor}>
          <App />

          < ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          pauseOnHover
          theme="light"
          />

        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
